function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#leaf-1_svg__filter0_f)"
}, React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-1_svg__filter1_d)"
}, React.createElement("path", {
  d: "M412.168 124.785l4.416-14.776 5.095-7.472 2.377 9.68-5.434 16.983-6.454 1.699v-6.114z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M412.168 130.899v-6.114l4.416-14.776 5.095-7.472m-9.511 28.362l6.454-1.699 5.434-16.983-2.377-9.68m-9.511 28.362l9.511-28.362",
  stroke: "#969696",
  strokeWidth: 0.581
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-1_svg__filter2_d)"
}, React.createElement("path", {
  d: "M42.757 33.284L20.424 18.928l-9.93-11.995 17.148.688 25.5 17.096-.272 11.486-10.113-2.919z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M52.87 36.203l-10.113-2.919-22.333-14.356-9.93-11.995m42.376 29.27l.271-11.486L27.642 7.62l-17.147-.688m42.375 29.27L10.495 6.933",
  stroke: "#969696"
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-1_svg__filter3_d)"
}, React.createElement("path", {
  d: "M68.356 393.119l13.351 7.871 8.862 2.026-4.864-8.76-15.61-8.802-5.918 3.159 4.178 4.506z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M64.177 388.613l4.178 4.506 13.352 7.871 8.862 2.026m-26.392-14.403l5.917-3.159 15.612 8.802 4.863 8.76m-26.392-14.403l26.392 14.403",
  stroke: "#969696",
  strokeWidth: 0.584
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-1_svg__filter4_d)"
}, React.createElement("path", {
  d: "M391.666 331.245l7.934 36.908-2.129 22.037-16.507-17.971-8.349-42.845 11.848-11.248 7.203 13.119z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M384.463 318.126l7.203 13.119 7.934 36.908-2.129 22.037m-13.008-72.064l-11.848 11.248 8.349 42.845 16.507 17.971m-13.008-72.064l13.008 72.064",
  stroke: "#969696",
  strokeWidth: 1.422
})));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "leaf-1_svg__filter0_f",
  x: 2.656,
  y: 0.166,
  width: 423.702,
  height: 412.064,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur"
})), React.createElement("filter", {
  id: "leaf-1_svg__filter1_d",
  x: 407.878,
  y: 101.835,
  width: 20.48,
  height: 37.44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-1_svg__filter2_d",
  x: 0.656,
  y: 2.166,
  width: 62.656,
  height: 42.696,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-1_svg__filter3_d",
  x: 59.706,
  y: 380.005,
  width: 37.317,
  height: 38.226,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-1_svg__filter4_d",
  x: 353.862,
  y: 316.975,
  width: 69.467,
  height: 85.877,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLeaf1 = function SvgLeaf1(props) {
  return React.createElement("svg", _extends({
    width: 429,
    height: 419,
    viewBox: "0 0 429 419",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgLeaf1 as ReactComponent };